import { useCookies } from '@/components/composable/composable_cookie'
import type { components, paths } from '@/types/gateway_schema'
import createClient from 'openapi-fetch'
import { defineStore } from 'pinia'

type GatewayStoreState = {
  dashboard?: components['schemas']['SopravisionDashboardDTO']
}

const client = createClient<paths>({
  baseUrl: '/gateway'
})

export const useDashboardStore = defineStore('dashboard', {
  state: (): GatewayStoreState => ({
    dashboard: undefined
  }),
  getters: {
    getDashboard: (state) => {
      return state.dashboard
    },
    getEUR: (state) => {
      return state.dashboard?.eur
    },
    getKWH: (state) => {
      return state.dashboard?.kwh
    },
    getM3: (state) => {
      return state.dashboard?.m3
    },
    getCO2: (state) => {
      return state.dashboard?.co2
    },
    getJWT: (_) => {
      const { getCookieValue } = useCookies()
      const cookie = getCookieValue('hv_jwt')
      return cookie
    }
  },
  actions: {
    async fetch(range?: { start: string; end: string }) {
      const response = await client.GET('/api/sopravision/dashboard', {
        params: {
          query: range ?? {
            start: '2025-01-01',
            end: '2025-12-31'
          }
        },
        headers: { 'X-AUTH-TOKEN': this.getJWT.value }
      })
      if (response.data) {
        this.dashboard = response.data
      }
    }
  }
})
